export class AuthError extends Error {
  readonly code: string;

  constructor(code: string, message: string) {
    super(message);
    this.name = "AuthError";
    this.code = code;
  }
}

// Better Auth は sign-up で USER_ALREADY_EXISTS_USE_ANOTHER_EMAIL を返す。
// USER_ALREADY_EXISTS は admin プラグイン由来で同じ意味なので同一翻訳に寄せる。
const ERROR_CODE_TO_I18N_KEY: Record<string, string> = {
  USER_ALREADY_EXISTS_USE_ANOTHER_EMAIL: "auth.errors.userAlreadyExists",
  USER_ALREADY_EXISTS: "auth.errors.userAlreadyExists",
  INVALID_EMAIL_OR_PASSWORD: "auth.errors.invalidEmailOrPassword",
  EMAIL_NOT_VERIFIED: "auth.errors.emailNotVerified",
  PASSWORD_TOO_SHORT: "auth.errors.passwordTooShort",
};

export function getAuthErrorI18nKey(code: string | undefined): string {
  if (!code) return "auth.errors.unknown";
  return ERROR_CODE_TO_I18N_KEY[code] ?? "auth.errors.unknown";
}
